import React from "react";

//Constants
import { quillFormats } from "../../../../constants/formWebConstants";

const renderOptions = (formatData, i) => {
    const { className, options } = formatData;
    return (
        <select key={i} className={className}>
            <option></option>
            {
                options.map((value, index) => {
                    const text = value.replace('px', '')
                    return (
                        <option value={value} key={index}>
                            {text}
                        </option>
                    )
                })
            }
        </select>
    )
}

const renderSingle = (formatData, i) => {
    const { className, value } = formatData;
    return (
        <button key={i} className={className} value={value}></button>
    )
}

const CustomToolbar = ({ id }) => (
    <div id={id}>
        {quillFormats.map((classes, index) => (
            <span className="ql-formats" key={index}>
                {classes.map((formatData, i) =>
                    formatData.options ? renderOptions(formatData, i) : renderSingle(formatData, i)
                )}
            </span>
        ))}
    </div>
);


export default CustomToolbar;